import { render, staticRenderFns } from "./MockPractical.vue?vue&type=template&id=50e30e74&"
import script from "./MockPractical.vue?vue&type=script&lang=js&"
export * from "./MockPractical.vue?vue&type=script&lang=js&"
import style0 from "./MockPractical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports